import React from "react"

import { ExclamationCircleIcon, XIcon } from "@heroicons/react/outline"

export default function Example(props) {
  const { close, text } = props
  return (
    <>
      <div className="fixed inset-x-0 bottom-0 z-50">
        <div className="bg-default-600">
          <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between flex-wrap">
              <div className="w-0 flex-1 flex items-center">
                <span className="flex p-2 rounded-lg bg-default-800">
                  <ExclamationCircleIcon
                    className="h-6 w-6 text-white"
                    aria-hidden="true"
                  />
                </span>
                <p className="ml-3 font-medium text-white truncate">
                  <span className="md:hidden">{text}</span>
                  <span className="hidden md:inline">{text}</span>
                </p>
              </div>
              <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
                <button
                  type="button"
                  className="-mr-1 flex p-2 rounded-md hover:bg-default-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
                  onClick={() => close()}
                >
                  <span className="sr-only">Dismiss</span>
                  <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
